import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbMissionPlanTemplate, IAloDbMissionPlanTemplateConstParam } from '@/models/alodb/AloDbMissionPlanTemplate'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getMissionPlanTemplates(): AxiosPromise<AlrContainer<AloBaseArray<AloDbMissionPlanTemplate>>> {    
    return apiHelpers.apiCall({ 
      url: 'api/admin/missionPlanTemplate', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbMissionPlanTemplate>>(JSON.parse(data),AloDbMissionPlanTemplate.createAloDbMissionPlanTemplateArray)
      }]
    })
  },
  getMissionPlanTemplate(id:number):AxiosPromise<AlrContainer<AloDbMissionPlanTemplate>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/missionPlanTemplate/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbMissionPlanTemplate>(JSON.parse(data),AloDbMissionPlanTemplate.createAloDbMissionPlanTemplateWithDetail)
      }]
    })
  },
  saveMissionPlanTemplate(missionPlanTemplate:AloDbMissionPlanTemplate):AxiosPromise<AlrContainer<AloDbMissionPlanTemplate>> {
    if(missionPlanTemplate.MPT_ID && missionPlanTemplate.MPT_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/missionPlanTemplate/${missionPlanTemplate.MPT_ID}`, 
        method: 'PUT',
        data: missionPlanTemplate,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMissionPlanTemplate>(JSON.parse(data),AloDbMissionPlanTemplate.createAloDbMissionPlanTemplateWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/missionPlanTemplate`, 
        method: 'POST',
        data: missionPlanTemplate,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbMissionPlanTemplate>(JSON.parse(data),AloDbMissionPlanTemplate.createAloDbMissionPlanTemplateWithDetail)
        }]
      })    
    }
    
  },
  deleteMissionPlanTemplate(id:number):AxiosPromise<AlrContainer<AloDbMissionPlanTemplate>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/missionPlanTemplate/${id}`, 
      method: 'DELETE',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })       
  }
  
}
/*
apiHelpers.addMocks({
  'api/admin/missionPlanTemplate': {
    'GET':() => {
      return  {
        resultCode:ApiResultCode.Ok,
        datStr:new Date(),
        data: AloDbMissionPlanTemplate.createAloDbMissionPlanTemplateArray(
          {
            items:[{
              MPT_ID : 1,
              ENS_ID : 1,
              MPT_LIBELLE : "Mission Plan 1",
              MPT_JSON : ""
              } as IAloDbMissionPlanTemplateConstParam
            ],              
            length:1,
            itemTypeName: 'AloDbMissionPlanTemplate'
          }),
        dataTypeName: 'AloDbMissionPlanTemplate'
      }
    }
  }
})*/